import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import { fetchCareerData } from "../../../redux/CareersSlice";
import { useLocation } from "react-router-dom";

const staticRoutes = {
  Home: "/",
  OurStory: "Our-Story",
  OurValues: "Our-Values",
  BoardMembers: "board-members",
  MeetTheCows: "meet-cows",
  TheMilkman: "The-milkman",
  Reefy: "Reefy",
  FindOurProducts: "Find-our-products",
  Recipes: "Recipes",
  MilkysFarm: "milkys-farm",
  OurFactory: "our-factory",
  Logistics: "Logistics",
  Csv: "csv",
  Careers: "Careers",
  ReachUs: "Reach-us",
};

export const Routes = {};
export const RoutesAr = {};
export const RoutesEn = {};

for (const key in staticRoutes) {
  RoutesAr[key] = staticRoutes[key] === "/" ? "/ar" : `/${staticRoutes[key]}/ar`;
  RoutesEn[key] = staticRoutes[key];
  Routes[key] = {
    ar: RoutesAr[key],
    en: RoutesEn[key],
  };
}

// Function to generate dynamic job routes
export const generateJobRoutes = (jobs) => {
  jobs.forEach((job) => {
    const id = `Job${job.jobId}`;
    RoutesAr[id] = `/Careers/${job.jobId}/ar`;
    RoutesEn[id] = `/Careers/${job.jobId}`;
    Routes[id] = {
      ar: RoutesAr[id],
      en: RoutesEn[id],
    };
  });
};

// Hook to fetch jobs and generate routes
export const useJobRoutes = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isArabic = location.pathname.includes("/ar");

  const jobs = useSelector((state) => state.career.data);
  const loading = useSelector((state) => state.career.loading);
  const error = useSelector((state) => state.career.error);
  const lastFetchedLang = useRef(null);

  // helper function
  const isArabicDataEmpty = (jobs) => {
    return jobs.every((job) => {
      return (
        job.JobName === null &&
        job.JobLocation === null &&
        job.JobType === null &&
        job.JobDepartment === null &&
        (job.JobH1Data === null || job.JobH1Data === "") &&
        (job.JobH2Data?.length === 0 || job.JobH2Data?.[0]?.JobH2Data1 === null) &&
        (job.JobH4Data?.length === 0 || job.JobH4Data?.every((item) => item.JobH4Data1 === null))
      );
    });
  };

  useEffect(() => {
    const lang = isArabic ? "ar" : "en";

    if (jobs.length === 0 && lastFetchedLang.current !== lang) {
      dispatch(fetchCareerData({ lang }))
        .unwrap()
        .then((data) => {
          // fallback if Arabic data is empty
          if (isArabic && isArabicDataEmpty(data)) {
            console.warn("Arabic data empty, refetching in English...");
            dispatch(fetchCareerData({ lang: "en" }));
            lastFetchedLang.current = "en";
          } else {
            lastFetchedLang.current = lang;
          }
        })
        .catch((err) => {
          console.error("Job fetch error:", err);
        });
    }
  }, [dispatch, isArabic, jobs.length]);

  useEffect(() => {
    if (jobs.length > 0) {
      generateJobRoutes(jobs);
    }
  }, [jobs]);

  return { jobs, loading, error };
};
